module.exports = __webpack_public_path__ + "static/media/now-playing.64c95e37.svg";